import logo from './logo.svg';
import './App.css';
import { ReservationDoctors } from './Components/ReservationDoctors';
import { BrowserRouter as Router, Switch, Route, Link, useRouteMatch, useParams } from "react-router-dom";
import { ReservationDaySelect } from './Components/ReservationDaySelect';
import { ReservationTimeSelect } from './Components/ReservationTimeSelect';
import { ReservationSet } from './Components/ReservationSet';

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route  path="/ReservationSet/:ID/:BeneficiaryCode/:BeneficiaryName/:FromPartTime/:ToPartTime/">
            <ReservationSet></ReservationSet>
          </Route>
         
          <Route  path="/ReservationTimeselect/:Code/:BeneficiaryCode/:BeneficiaryName/">
            <ReservationTimeSelect></ReservationTimeSelect>
          </Route>
          <Route  path="/Reservationdayselect/:BeneficiaryCode/:BeneficiaryName">
            <ReservationDaySelect></ReservationDaySelect>
          </Route>
          <Route exact path="/">
            <ReservationDoctors></ReservationDoctors>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
